import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Header from './components/app_body/header.jsx';
import Body from './components/app_body/body.jsx';
import { authenticationService } from './services/authenticationService.js';
import { createBrowserHistory } from 'history';
import MediaQuery from 'react-responsive';

export const history = createBrowserHistory();

export default class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentUser: null
        }

        this.setUser = this.setUser.bind(this);
        
    }

    setUser(user) {
        this.setState({ currentUser: user });
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(x => this.setUser(x));
    }

    render() {
        const {currentUser} = this.state;
        return (
            <Router history={history}>
                <div>
                    <MediaQuery minDeviceWidth={1224}>
                        <div>
                            { currentUser && <Header /> }
                            <Body />
                        </div>
                    </MediaQuery>
                    <MediaQuery maxDeviceWidth={1224}>
                        <div className="mobile_view">
                            {currentUser && <Header />}
                            <Body />
                        </div>
                    </MediaQuery>
                </div>
            </Router>
        );
    }
};